module.exports = __webpack_public_path__ + "dc7e5f1b575fb48e921acb2d133fb5f2.png";